import React from "react";
import '../../ChatApp.css';
import { ReactComponent as IconCalendar } from "../../images/svg/calender.svg";
import { ReactComponent as IconCopy } from "../../images/svg/copy.svg";
import { ReactComponent as IconClose } from "../../images/svg/close.svg";
import { ReactComponent as IconCheck } from "../../images/svg/check.svg";


function InfoContent({ meetingInfo, closeInfoContent, infoClass }) {
    const [copied, setCopied] = React.useState(false);
    const guestInviteUrl = meetingInfo?.guest_invite_url || meetingInfo?.invite_url || "";

    

    const formatMeetingTime = (timestamp) => {
        if (!timestamp) return "N/A";
        
        const date = new Date(timestamp);
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        
        return `${formattedHours}:${formattedMinutes} ${ampm}`;
    };

    const formatMeetingDate = (timestamp) => {
        if (!timestamp) return "N/A";
        
        const date = new Date(timestamp);
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun", 
            "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
        ];
        
        return `${days[date.getDay()]}, ${months[date.getMonth()]} ${date.getDate()}`;
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(guestInviteUrl).then(() => {
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
                closeInfoContent();
            }, 2000);
        });
    };

    return (
        <>

        <div className={infoClass}>
            <div className="dialog-box">
                <span className="dialog-box-close" onClick={closeInfoContent}>
                    <IconClose/>
                </span>
                <div className="dialog-box-title">Here's meeting information</div>
                <div className="dialog-box-content">
  
                        <div className="dialog-meeting-info-title">
                            {meetingInfo?.meeting_title || "N/A"}
                        </div>
                        <div className="dialog-meeting-info-time">
                            <IconCalendar/>
                            <span>{formatMeetingDate(meetingInfo?.meeting_time)}; {formatMeetingTime(meetingInfo?.meeting_time)} - {formatMeetingTime(meetingInfo?.ending_time)}</span>
                        </div>

                        <div className="dialog-meeting-info-link-label">
                            Meeting Link
                        </div>
                        <div className="dialog-meeting-info-link-container">
                           <span className="dialog-meeting-info-link">
                           {guestInviteUrl && guestInviteUrl.length > 28
                            ? `${guestInviteUrl.substring(0, 29)}...`
                            : guestInviteUrl}
                           </span>
                           <span onClick={handleCopy} className="dialog-meeting-info-link-copy"> 
                                 {copied ? <IconCheck/> : <IconCopy/>} 
                            </span>
                        </div>
                </div>
            </div>
        </div>








            {/* <div id="information-preview-content">
                <div className="meeting meeting-title-section">
                    <h2 className="meeting meeting-main-title">
                        {meetingInfo?.meeting_title || "N/A"}
                    </h2>
                </div>

                <div className="meeting meeting-credential">
                    {meetingInfo?.meeting_desc && (
                        <div className="meeting meeting-credential-title">
                            Description: <span className="meeting meeting-credential-value">{meetingInfo.meeting_desc}</span>
                        </div>
                    )}

                    <div className="meeting meeting-credential-title">
                        Meeting Time: <span className="meeting meeting-credential-value">
                            {formatMeetingTime(meetingInfo?.meeting_time)}
                        </span>
                    </div>

                    <div className="meeting meeting-credential-title">
                        Date: <span className="meeting meeting-credential-value">
                            {formatMeetingDate(meetingInfo?.meeting_time)}
                        </span>
                    </div>

                    <div className="meeting meeting-credential-title">
                        Meeting ID: <span className="meeting meeting-credential-value">{meetingInfo?.meeting_id || "N/A"}</span>
                    </div>
                </div>

                <div className="meeting meeting-link-title">Meeting link:</div>
                <div className="meeting meeting-link-row">
                    <div className="meeting meeting-link-url">
                        {guestInviteUrl && guestInviteUrl.length > 28
                            ? `${guestInviteUrl.substring(0, 29)}...`
                            : guestInviteUrl}
                    </div>
                    <button className="meeting meeting-link-copy-button" onClick={handleCopy}>
                        {copied ? "Copied!" : "Copy"}
                    </button>
                </div>
            </div> */}
        </>
    );
}

export default InfoContent;
